// Task 244: the engine's call incidents (creator's names) land in a bounded window.__inspireCallIncidents log for
// debugging and specs. q3po has no incident sink yet; a server endpoint would replace this binding.
import { registerHostInjections } from "@bloglovin/inspire-engine/Host";

export const CALL_INCIDENT_LOG_SIZE = 50;

export function registerCallIncidentLog({ register = registerHostInjections, target = window, debug = console.debug } = {}) {
  target.__inspireCallIncidents = [];
  register({
    telemetry: {
      callIncident(incident) {
        const log = target.__inspireCallIncidents;
        log.push(incident);
        if (log.length > CALL_INCIDENT_LOG_SIZE) log.splice(0, log.length - CALL_INCIDENT_LOG_SIZE);
        debug(`[q3po] call incident ${incident.type} (${incident.severity})`, incident.details);
      },
    },
  });
}
